import * as React from 'react'
import { FC, useCallback } from 'react'

import { NoResultsCard } from '@sales-center/components'
import { ISalesFunnel } from '@user/store/salesFunnel/typings'
import {
  useDeleteSalesFunnel,
  useSetDefaultSalesFunnel,
} from '@user/store/salesFunnel/hooks'
import { SalesFunnelCard } from './SalesFunnelCard'
import { Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useDuplicateSalesFunnel } from '@user/store/salesFunnel/hooks/useDuplicateSalesFunnel'

interface Props {
  salesFunnels: ISalesFunnel[]
  setEditId: (id: string) => void
}

const styles = {
  manage: {
    marginTop: (theme: Theme) => theme.spacing(3),
    marginBottom: (theme: Theme) => theme.spacing(1.5),
    fontSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
    lineHeight: (theme: Theme) => theme.spacing(2.4),
    height: (theme: Theme) => theme.spacing(2.4),
  },
}

export const SalesFunnelList: FC<Props> = ({ salesFunnels, setEditId }) => {
  const deleteFunnel = useDeleteSalesFunnel()
  const setDefault = useSetDefaultSalesFunnel()
  const { onClickDuplicateFunnel } = useDuplicateSalesFunnel()

  const editFunnel = useCallback((id: string) => setEditId(id), [setEditId])

  return (
    <>
      <Typography variant="h4" sx={styles.manage}>
        Manage Your Sales Funnels
      </Typography>
      {salesFunnels.length == 0 ? (
        <NoResultsCard label="No sales funnels added yet" />
      ) : (
        salesFunnels.map((s) => (
          <SalesFunnelCard
            key={s.id}
            salesFunnel={s}
            deleteFunnel={deleteFunnel}
            setDefault={setDefault}
            editFunnel={editFunnel}
            duplicateFunnel={onClickDuplicateFunnel}
          />
        ))
      )}
    </>
  )
}
